import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import 'date-fns';
import clsx from 'clsx';
import {
  Backdrop, Card, CardHeader, Radio, RadioGroup, FormControl, FormControlLabel, Divider, Typography,
  IconButton, InputLabel, Select, InputAdornment, TextField, Button, CardContent, CircularProgress,
  Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions
} from "@material-ui/core";
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css';
import CropFreeIcon from '@material-ui/icons/CropFree';
import axios from 'src/utils/axios';
import Page from 'src/components/Page';
import BarkodPopup from 'src/components/BarcodePopup';
import { getUser } from 'src/utils/Common';
import logger from 'src/utils/logger';

const useStyles = makeStyles((theme) => ({
  root: { flexGrow: 1 },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  fieldsGaranti: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  contentGaranti: {
    minHeight: 430,
  },
  submitButtonAeee: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
}));

function Aeee({ className, FisNo }) {
  const classes = useStyles();
  const user = getUser();
  const [Loading, setLoading] = useState(false);
  const [urunAlindi, setUrunAlindi] = useState(false);
  const [atikUrun, setAtikUrun] = useState("");
  const [atikMarka, setAtikMarka] = useState("");
  const [aeeeNot, setAeeeNot] = useState("");
  const [aeeeEtiket, setAeeeEtiket] = useState("");
  const [atikUrunData, setAtikUrunData] = useState([]);
  const [atikMarkaData, setAtikMarkaData] = useState([]);
  const [openBarkod, setOpenBarkod] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [Uyari, setUyari] = React.useState("");
  const [isClickDisable, setIsClickDisable] = React.useState(false);

  useEffect(() => {
    let isMounted = true;
    axios.get('/GetArtemisAeeeUrun').then((response) => {
      if (!isMounted) return;
      const AeeeUrun = response.data;
      if (AeeeUrun.length === 0) {
        setAtikUrunData([]);
      } else {
        setAtikUrunData(AeeeUrun);
      }
    }).catch(error => {
      logger.error("Hata detayı:", error.message);
    });
    axios.get('/GetArtemisAeeeMarka').then((response) => {
      if (!isMounted) return;
      const AeeeMarka = response.data;
      if (AeeeMarka.length === 0) {
        setAtikMarkaData([]);
      } else {
        setAtikMarkaData(AeeeMarka);
      }
    }).catch(error => {
      logger.error("Hata detayı:", error.message);
    });

    return () => {
      isMounted = false;
    };
  }, []);
  const handleRadioChange = (event) => {
    event.target.value === "0" && handleAeeeAlinamadiMailAt(FisNo);
    setUrunAlindi(event.target.value === "1");
  }
  const handleChangeAtikUrun = (event) => setAtikUrun(event.target.value);
  const handleChangeAtikMarka = (event) => setAtikMarka(event.target.value);
  const handleChangeAeeeNot = (event) => setAeeeNot(event.target.value);
  const handleChangeAeeeEtiket = (event) => setAeeeEtiket(event.target.value);
  const handleBarkodOpen = () => setOpenBarkod(true);
  const handleBarkodClose = async (barkod) => {
    setOpenBarkod(false);
    if (barkod.length === undefined) {
      return;
    }
    setAeeeEtiket(barkod);
  }
  const handleClose = () => {
    setOpen(false);
  };
  const matchServicePaper = () => {
    setIsClickDisable(true); 
    const data = {
      FisNo: FisNo,
      UrunAlindi: "1",
      Etiket: aeeeEtiket,
      Urun: atikUrun,
      Marka: atikMarka,
      Notlar: aeeeNot,
      TeknisyenKodu: user.TechnicianId,
      BirimKodu: user.ServiceShopId,
    };
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios.post('/SetArtemisAeeeEslenikFisOlustur', JSON.stringify(data), config).then((response) => {
      setLoading(false);
      const res = response.data;
      if (parseInt(res.ErrorCode) !== 0) {
        setUyari(res.ErrorDescription);
        setOpen(true);
        setIsClickDisable(false);
      } else {
        setUyari("İşleminiz gerçekleştirildi. Okuttuğunuz AEEE barkodunu eski ürünün üzerine yapıştırmayı unutmayınız!...");
        setOpen(true);
      }
    })
  }
  const handleAeeeMailAt = (FisNo) => {
    setIsClickDisable(true);  
    const data = {
      FisNo: FisNo,
      UrunAlindi: "0",
      Etiket: "",
      Urun: 0,
      Marka: 0,
      Notlar: "",
      TeknisyenKodu: user.TechnicianId,
      BirimKodu: user.ServiceShopId,
    };
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios.post('/SetArtemisAeeeEslenikFisOlustur', JSON.stringify(data), config).then((response) => {
      setLoading(false);
      const res = response.data;
      if (parseInt(res.ErrorCode) !== 0) {
        setUyari(res.ErrorDescription);
        setOpen(true);
        setIsClickDisable(false);  
      } else {
        setUyari("Mail gönderim listesine eklenmiştir!...");
        setOpen(true);
        setIsClickDisable(false);  
      }
    })
  }
  const handleAeeeAlinamadiMailAt = (FisNo) => {
    var Uyari = "Bayiye ürün alınamadığı bildirilecektir. Onaylıyor musunuz?";
    confirmAlert({
      message: Uyari,
      buttons: [
        {
          label: 'Evet',
          onClick: () => handleAeeeMailAt(FisNo)
        },
        {
          label: 'Hayır',
          onClick: () => { return; }
        }
      ]
    });

  }
  return (
    <Page className={classes.root} title="Aeee">
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">{"Bilgilendirme"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {Uyari}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Tamam
      </Button>
        </DialogActions>
      </Dialog>
      <Card
        className={clsx(classes.root, className)}
      >
        <CardHeader title="Aeee" />
        <Divider />
        {
          Loading ?
            <Backdrop className={classes.backdrop} open={Loading}>
              <CircularProgress color="inherit" />
            </Backdrop>
            : <div></div>
        }
        <CardContent>
          <Typography className={classes.title} color="textSecondary" component="span">
            <RadioGroup aria-label="secim" name={"AeeeRadioGroup"} onChange={(e) => handleRadioChange(e)}>
              <FormControlLabel value="0" control={<Radio color="primary" />} label={"Eskisi hazır değil. Müşteri teslim etmedi."} />
              <FormControlLabel value="1" control={<Radio color="primary" />} label={"AEEE ürünü teslim alındı."} />
            </RadioGroup>
          </Typography>
          <Divider />
          {
            urunAlindi
            &&
            <div>
              <FormControl variant="outlined" className={classes.submitButtonAeee}>
                <TextField
                  name="AeeeEtiket"
                  label={"AEEE Etiket"}
                  value={aeeeEtiket || ''}
                  onChange={e => handleChangeAeeeEtiket(e)}
                  fullWidth
                  variant="outlined"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment>
                        <IconButton color="primary" aria-label="settings" onClick={handleBarkodOpen} >
                          <CropFreeIcon />
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
              </FormControl>
              <FormControl variant="outlined" className={classes.submitButtonAeee}>
                <InputLabel id="demo-simple-select-outlined-label" >{"AEEE Urun"}</InputLabel>
                <Select
                  fullWidth
                  native
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  onChange={handleChangeAtikUrun}
                  label={"AEEE Ürün"}
                  hidden={true}
                  value={atikUrun}
                >
                  <option value="" defaultValue></option>
                  {atikUrunData.map(p => {
                    return <option key={p.ModelKodu} value={p.ModelKodu}>{p.AtikUrun}</option>
                  })}
                </Select>
              </FormControl>
              <FormControl variant="outlined" className={classes.submitButtonAeee}>
                <InputLabel id="demo-simple-select-outlined-label" >{"AEEE Marka"}</InputLabel>
                <Select
                  fullWidth
                  native
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  onChange={handleChangeAtikMarka}
                  label={"AEEE Marka"}
                  hidden={true}
                  value={atikMarka}
                >
                  <option value="" defaultValue></option>
                  {atikMarkaData.map(p => {
                    return <option key={p.MarkaKodu} value={p.MarkaKodu}>{p.AtikMarka}</option>
                  })}
                </Select>
              </FormControl>
              <FormControl variant="outlined" className={classes.submitButtonAeee}>
                <TextField
                  name="AeeeNot"
                  label={"Notlar"}
                  value={aeeeNot || ''}
                  onChange={handleChangeAeeeNot}
                  fullWidth
                  variant="outlined"
                />
              </FormControl>
              <br />
              <Button
                variant="contained"
                color="secondary"
                className={classes.submitButtonAeee}
                onClick={matchServicePaper}
                disabled={isClickDisable}
              >
                Eşlenİk Fİş Oluştur
                        </Button>
              <BarkodPopup
                onClose={handleBarkodClose}
                open={openBarkod}
                ScanTime={0}
                CallScreen={0}
              />
            </div>
          }
        </CardContent>
      </Card>
    </Page>
  );
}

Aeee.propTypes = {
  className: PropTypes.string,
};


export default connect(
  state => ({
    tasks: state.tasks1,
    defectReducer: state.defectReducer,
    labourReducer: state.labourReducer,
    materialReducer: state.materialReducer,
  })
)(Aeee);
